import { PrintTicket } from '../types/chrome-box-messages';

export interface PrinterProperties {
    printerName: string;
    printerId: string;
    dpi?: {
        horizontal_dpi: unknown;
        vertical_dpi: unknown;
    };
    performTrim: unknown;
    continuous_feed: boolean;
}

export interface PrinterCapabilities {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vendor_capability?: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    media_size?: { option: any[] };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dpi?: { option: any[] };
}

export class PrintTicketBuilder {
    private constructor(
        private printer: chrome.printing.Printer,
        private printerInfo: chrome.printing.GetPrinterInfoResponse
    ) { }

    private preparePrinterProperties(): PrinterProperties {
        const printerCapabilities = <PrinterCapabilities | undefined>(
            this.printerInfo?.capabilities?.['printer']
        );
        const performTrim = printerCapabilities?.vendor_capability?.some(
            (capability) => capability.display_name == 'finishings/11'
        );

        // const continuous_feed = printerCapabilities?.media_size?.option.find(
        //     (option) => option.is_continuous_feed
        // );

        return {
            printerName: this.printer.name,
            printerId: this.printer.id,
            dpi: printerCapabilities?.dpi?.option[0],
            performTrim: !!performTrim,
            continuous_feed: false,
        };
    }

    private createPrintTicket(): PrintTicket {
        const printProperties: PrinterProperties = this.preparePrinterProperties();
        const ticket: PrintTicket = {
            version: '1.0',
            print: {
                color: { type: 'STANDARD_MONOCHROME' },
                duplex: { type: 'NO_DUPLEX' },
                page_orientation: { type: 'LANDSCAPE' },
                copies: { copies: 1 },
                collate: { collate: false }
            }
        };

        if (printProperties.dpi) {
            ticket.print.dpi = {
                horizontal_dpi: printProperties.dpi.horizontal_dpi,
                vertical_dpi: printProperties.dpi.vertical_dpi
            };
        }

        if (printProperties.continuous_feed) {
            ticket.print.media_size = {
                width_microns: 72320,
                // Note that this value needs to be between min_height_microns and
                // max_height_microns.  Usually this matches the height of the document
                // being printed.
                height_microns: 110000
            };
            // This only makese sense to specify if the printer supports the trim
            // option.
            if (printProperties.performTrim) {
                ticket.print.vendor_ticket_item = [{ id: 'finishings', value: 'trim' }];
            }
        } else {
            ticket.print.media_size = {
                width_microns: 210000,
                height_microns: 297000,
                vendor_id: 'iso_a4_210x297mm'
            };
        }

        return ticket;
    }

    static build(
        printer: chrome.printing.Printer,
        printerInfo: chrome.printing.GetPrinterInfoResponse | null
    ): PrintTicket | null {
        if (!printerInfo) {
            return null;
        }

        return new PrintTicketBuilder(printer, printerInfo).createPrintTicket();
    }
}
